import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from './admin'
import Code from './code'

import page404 from '@/components/page404'
export default new VueRouter({
  routes: [
    ...Admin,
    ...Code,
    {
      path: '/404',
      name: '404',
      component: page404,
    },
    {
      path: '*', // 此处需特别注意至于最底部
      redirect: '/404'
    }
  ],
  mode: 'history',
  base: '/admin'
})
Vue.use(VueRouter);



// WEBPACK FOOTER //
// ./src/router/index.js